import React from 'react';
import { useClient } from '../../context/ClientContext';

const icons = {
  'Brand Campaign': (
    <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 6h.008v.008H6V6z" />
    </svg>
  ),
  'All Locations': (
    <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 15.803a7.5 7.5 0 0010.607 0z" />
    </svg>
  ),
  'Performance Max': (
    <svg className="w-5 h-5 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
    </svg>
  )
};

export default function CampaignCards({ data }) {
  const { brand, dataSources } = useClient();
  const currencySymbol = dataSources?.googleAds?.currencySymbol || brand?.currencySymbol || '$';

  if (!data || data.length === 0) return null;

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide"
          style={{ fontFamily: brand.typography?.headerFont }}>
        Campaign Performance
      </h3>
      {data.map((card, i) => (
        <div key={i} className="bg-white rounded-xl shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100 p-5">
          <div className="flex items-center gap-2 mb-1">
            {icons[card.label] || icons['All Locations']}
            <h4 className="text-base font-semibold text-gray-900"
                style={{ fontFamily: brand.typography?.headerFont }}>
              {card.label}
            </h4>
          </div>

          {card.description && (
            <p className="text-xs text-gray-400 mb-3 ml-7">{card.description}</p>
          )}

          <div className="flex gap-6 ml-7">
            <div>
              <p className="text-2xl font-bold" style={{ color: brand.colors?.primary }}>
                {card.enquiries}
              </p>
              <p className="text-xs text-gray-500">enquiries</p>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900">
                {card.enquiries > 0 ? `${currencySymbol}${card.costPerEnquiry.toFixed(0)}` : '\u2014'}
              </p>
              <p className="text-xs text-gray-500">per enquiry</p>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900">{card.clicks}</p>
              <p className="text-xs text-gray-500">clicks</p>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900">{currencySymbol}{card.cost.toFixed(0)}</p>
              <p className="text-xs text-gray-500">spend</p>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-900">
                {card.impressions > 0 ? `${((card.clicks / card.impressions) * 100).toFixed(1)}%` : '\u2014'}
              </p>
              <p className="text-xs text-gray-500">CTR</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
